import { FunctionComponent, useEffect, useState } from "react";
import { PDFViewer, PDFDownloadLink } from "@react-pdf/renderer";
import BasicInfoForm from "../BasicInfoForm";
import CreditQuiz101 from "./CreditQuiz101";
import BasicFinancialPass from "src/pages/website/Education/BasicFinancialPass";
import { Link } from "react-router-dom";
import { images } from "src/utils";
import { LoadingSpinner } from "src/components/generic";
import certificateBg from "src/assets/credit-basics-101.jpeg";



const BasicFinancialQuizForm: FunctionComponent = () => {
    const [view, setView] = useState<'start' | 'active' | 'pass'>('start');
    const [studentName, setStudentName] = useState<string>('');
    const [email, setEmail] = useState<string>('');
    const [certificateBgData, setCertificateBgData] = useState<string | null>(null);

    useEffect(() => {
        images.loadImageAsDataURL(certificateBg)
        .then(setCertificateBgData);
    }, []);
    console.log(certificateBg?.slice(0, 60));
    console.log(certificateBgData?.slice(0, 60));
    if(!certificateBgData) return <LoadingSpinner />
    return (
        <div className="mb-10">
            {
                view === 'start' ? <BasicInfoForm confirmSubmit={(value: boolean) => { if(value) setView('active') }} setStudentName={(name: string) => setStudentName(name)} setStudentEmail={(email: string) => setEmail(email)} /> : 
                view === 'active' ? <CreditQuiz101 name={studentName} email={email} confirmSubmit={(value: boolean) => { if(value) setView('pass') }} /> :
                view === 'pass' ? <div className="py-12">
                    <h2 className="text-3xl font-semibold mb-4 text-center">✅ Quiz passed! Awesome work—nice job showing what you know!</h2>
                    <h3 className="text-2xl font-semibold mb-4 text-center">
                        For full utilization for ClientVitals services or assitance with pre-qualification readiness 
                        <Link to="/auth/client-registration?tier=bronze"><span  className="text-primary hover:underline"> register here for $5 / mo</span></Link>
                    </h3>
                    <PDFViewer width="100%" height={600}><BasicFinancialPass background={certificateBgData} name={studentName} /></PDFViewer> 
                </div> :
                <p>Error State</p>
            }
        </div>
    )
};

export default BasicFinancialQuizForm;